<template>
  <div>
    <div id="nav" class="w-100 position-relative top-50 start-0">
      <!-- <router-link to="/" class="btn btn-warning me-4 me-1">Paises</router-link>
      <router-link to="/about" class="btn btn-warning">Creador</router-link> -->
    </div>
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}
</style>
